import { cn } from "cn";
import { Skeleton } from "@/components/ui/skeleton";

/** Lines of text still on their way — a short heading line, then a paragraph. */
export function RichTextSkeleton({ className }: { className?: string }) {
  return (
    <div
      aria-busy="true"
      data-test="rich-text-skeleton"
      className={cn("flex flex-col gap-2", "w-full", className)}
    >
      <Skeleton className="h-4 w-16" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-11/12" />
      <Skeleton className="h-4 w-3/4" />
    </div>
  );
}
